import React from 'react';
import {
  FDBodyText, FDHeadlineText, FDStack,
} from '@facet-wealth/design';
import useMobileLayout from 'Hooks/useMobileLayout';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverrideLite';
import { buildFacetDesignOverride } from 'Packages/FacetRest/FacetDesignOverride';
import { dataAttrs } from 'Helpers/Testing';
import { OutcomeInvestmentDetailsAccountDetailsSection } from '../OutcomeInvestmentDetailsAccountDetailsSection/OutcomeInvestmentDetailsAccountDetailsSection';

export const convertChartDataCollectionToObjectArray = (chartDataCollection) => {
  if (!chartDataCollection?.resources()?.list()) {
    return [];
  }
  // Filter out values that are non numeric. This is just a guardrail to avoid unplugs incase the server returns something unexpected
  const filteredChartData = chartDataCollection.resources().list().filter(data => {
    const numValue = Number(data.attr('value'));
    return !Number.isNaN(numValue);
  });
  return filteredChartData.map((res) => ({
    color: res.attr('color'),
    label: res.attr('label'),
    name: res.attr('label'), // Using label as the name intentionally
    type: res.attr('type'),
    value: Number(res.attr('value')),
  }));
};

const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride('expenseRatio', {
    _component: () => FDBodyText,
    _customProps: {
      color: 'textSecondary',
    },
  }, overrideReadOnly)
  .nameOverride('title', {
    _component: () => FDHeadlineText,
    _customProps: {
      color: 'textSecondary',
    },
  }, overrideReadOnly)
  .nameOverride('description', {
    _component: () => FDBodyText,
    _customProps: {
      size: 'lg',
    },
  }, overrideReadOnly)
  .nameOverride('disclosure', {
    _component: () => FDBodyText,
    _customProps: {
      size: 'sm',
      align: 'center',
      color: 'textDisabled',
    },
  }, overrideReadOnly)
  .done();


const OutcomeInvestmentDetailsOverviewLayout = ({ collection }) => {
  const isMobile = useMobileLayout();

  const resource = collection?.resources()?.head();
  if (!resource) {
    return null;
  }

  const allocationMixChartData = convertChartDataCollectionToObjectArray(resource?.attr('allocationClassificationData'));
  const tickerMixChartData = convertChartDataCollectionToObjectArray(resource?.attr('tickerClassificationData'));

  return (
    <MetaResourceRenderer
      resource={resource}
      metaOverrideSet={metaOverrideSet}
      layout={() => (
        <FDStack direction={'column'} spacing={isMobile ? 2 : 6} width={'100%'} {...dataAttrs('investment-details-overview-layout')}>
          <OutcomeInvestmentDetailsAccountDetailsSection
            allocationMixChartData={allocationMixChartData}
            tickerMixChartData={tickerMixChartData}
          />
        </FDStack>
      )}
    />
  );
};

export { OutcomeInvestmentDetailsOverviewLayout };
